<template>
  <div class="drop-box">
    <CommonDrop
      v-model="currentValue"
      url="/trade/customer/list"
      :autoDefault="false"
      :disabled="disabled"
      :clearable="clearable"
      ref="drop"
      size="mini"
      :filterable="true"
    ></CommonDrop>
    <!-- <el-button type="text" @click="addNew" v-if="showBtn" class="btn">新建客户</el-button>
    <AddOrUpdate
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="$refs.drop.getDataList()"
    ></AddOrUpdate> -->
  </div>
</template>
<script>
import CommonDrop from "@/components/CommonDrop";
import AddOrUpdate from "@/views/modules/trade/customer/add-or-update";

export default {
  components: { CommonDrop, AddOrUpdate },
  name: "Customer",
  data() {
    return {
      addOrUpdateVisible: false,
    };
  },
  props: {
    value: {
      type: String | Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    showBtn:{
      type:Boolean,
      default:false
    }
  },
  computed: {
    currentValue: {
      get() {
        if (this.value === null || this.value === undefined) {
          return "";
        }
        return String(this.value);
      },
      set(newVal) {
        this.$emit("input", newVal);
        this.$emit("change", newVal);
      },
    },
  },
  methods: {
    addNew() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.drop-box {
  display: flex;
  align-items: flex-end;
  .btn {
    margin-left: 10px;
  }
}
</style>
